import React from 'react';
import { useDispatch } from 'react-redux';
import { actions } from '../../../context';
import { ListGroupItem } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { emptyGuid } from '../../Shared/TextHelpers';
import Split from '../../Shared/Split';

const NewPracticeButton = () => {
    const dispatch = useDispatch();

    const goToWorkflowNextStep = () =>
        dispatch(
            actions.practiceWorkflow.setWorkflowStatus({
                loading: false,
                searchingPractices: false,
                editingPractice: true,
                editingRelations: false,
            })
        );

    const resetWorkflowFilter = () =>
        dispatch(actions.practiceWorkflow.setWorkflowFilter(''));

    const CreateNewWorkflowPractice = () => {
        dispatch(actions.practiceWorkflow.getPractice(emptyGuid)).then(
            (res) => {
                resetWorkflowFilter();
                goToWorkflowNextStep();
            }
        );
    };

    return (
        <ListGroupItem action className="hoverable py-3" onClick={CreateNewWorkflowPractice}>
            <Split>
                Create New Practice
                <FontAwesomeIcon size="lg" icon={faEdit}></FontAwesomeIcon>
            </Split>
        </ListGroupItem>
    );
};

export default NewPracticeButton;
